// Phase 6.0 · 쇼핑 숏클립 스트립 (홈 · 기존 AD 5개 자리 대체)
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Play, ChevronRight, Sparkles } from 'lucide-react';
import api from '@/lib/api';

const won = (n) => `${(Number(n) || 0).toLocaleString('ko-KR')}원`;

// Mock fallback · 실제 클립이 등록되기 전에도 UI 위치 확인 가능.
const MOCK_CLIPS = [
  { clip_id: 'mock1', thumbnail_url: 'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=400&auto=format', seller_snapshot: { name: '뷰티 셀러 · A' }, product_snapshot: { name: '데일리 립밤', sale_price: 12900 } },
  { clip_id: 'mock2', thumbnail_url: 'https://images.unsplash.com/photo-1483985988355-763728e1935b?w=400&auto=format', seller_snapshot: { name: '패션 셀러 · B' }, product_snapshot: { name: '베이직 셔츠', sale_price: 29000 } },
  { clip_id: 'mock3', thumbnail_url: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&auto=format', seller_snapshot: { name: '푸드 셀러 · C' }, product_snapshot: { name: '수제 그래놀라', sale_price: 8900 } },
  { clip_id: 'mock4', thumbnail_url: 'https://images.unsplash.com/photo-1544441893-675973e31985?w=400&auto=format', seller_snapshot: { name: '리빙 셀러 · D' }, product_snapshot: { name: '무선 램프', sale_price: 45000 } },
  { clip_id: 'mock5', thumbnail_url: 'https://images.unsplash.com/photo-1611095973763-414019e72400?w=400&auto=format', seller_snapshot: { name: '펫 셀러 · E' }, product_snapshot: { name: '유기농 간식', sale_price: 15000 } },
];

export default function ShortClipStrip() {
  const [clips, setClips] = useState([]);
  const [isMock, setIsMock] = useState(false);

  useEffect(() => {
    api.get('/public/short-clips?limit=10')
      .then((r) => {
        const items = r.data?.items || [];
        if (items.length) { setClips(items); setIsMock(false); }
        else { setClips(MOCK_CLIPS); setIsMock(true); }
      })
      .catch(() => { setClips(MOCK_CLIPS); setIsMock(true); });
  }, []);

  if (!clips.length) return null;

  return (
    <section className="py-6 sm:py-8 border-b border-black/5 dark:border-white/10 bg-gradient-to-b from-white to-orange-50/30 dark:from-[#0A0A0A] dark:to-orange-950/10" data-testid="home-short-clips">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between mb-3 sm:mb-4">
          <div className="flex items-center gap-2">
            <Sparkles className="text-[#FF3B30]" size={20}/>
            <h2 className="text-xl sm:text-2xl font-black tracking-tight" style={{ fontFamily: 'Manrope, sans-serif' }} data-testid="short-clips-title">
              🎬 지금 뜨는 쇼핑
            </h2>
            {isMock && <span className="text-[10px] font-bold px-1.5 py-0.5 rounded bg-amber-500/10 text-amber-700">준비중</span>}
          </div>
          <Link to="/short-clips" className="text-xs sm:text-sm font-bold text-[#FF3B30] hover:underline inline-flex items-center gap-0.5" data-testid="short-clips-viewall">
            전체보기 <ChevronRight size={14}/>
          </Link>
        </div>

        <div className="flex gap-3 overflow-x-auto snap-x scroll-smooth pb-3
          [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
          {clips.map((c) => {
            const seller = c.seller_snapshot || {};
            const product = c.product_snapshot || {};
            return (
              <Link key={c.clip_id}
                to={isMock ? '#' : '/short-clips'}
                state={isMock ? undefined : { initialClip: c }}
                onClick={isMock ? (e) => e.preventDefault() : undefined}
                className="snap-start shrink-0 relative w-[46%] sm:w-[220px] rounded-2xl overflow-hidden border border-black/10 dark:border-white/10 bg-white dark:bg-[#141414] hover:shadow-lg hover:-translate-y-0.5 transition-all"
                data-testid={`short-clip-${c.clip_id}`}>
                <div className="relative aspect-[9/16] bg-gray-100 dark:bg-white/5">
                  <img src={c.thumbnail_url} alt={product.name} loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover"/>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"/>
                  <div className="absolute top-2 left-2 flex gap-1 flex-wrap max-w-[80%]">
                    {c.is_featured && <span className="px-1.5 py-0.5 rounded-full bg-[#FF3B30] text-white text-[9px] font-black">★ 추천</span>}
                    {c.is_sponsored && <span className="px-1.5 py-0.5 rounded-full bg-black text-white text-[9px] font-black">Sponsored</span>}
                  </div>
                  <div className="absolute top-2 right-2 w-8 h-8 rounded-full bg-white/90 flex items-center justify-center">
                    <Play size={14} className="text-black ml-0.5"/>
                  </div>
                  <div className="absolute inset-x-0 bottom-0 p-2.5 text-white">
                    <p className="text-[10px] font-bold text-white/80 truncate">{seller.name || '판매자'}</p>
                    <p className="text-xs sm:text-sm font-black truncate">{product.name}</p>
                    <p className="text-sm sm:text-base font-black" style={{ fontFamily: 'Manrope, sans-serif' }}>{won(product.sale_price)}</p>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}

